const dict = {
  custom: {
    organization_name: {
      required: () => '会社名・組織名を入力してください。',
      max: (name, max) => `${max}文字以内で入力してください。`,
    },
    name_person: {
      required: () => 'お名前(担当者様)を入力してください。',
      max: (name, max) => `${max}文字以内で入力してください。`,
    },
    name: {
      required: () => '氏名を入力してください。',
      max: (name, max) => `${max}文字以内で入力してください。`,
    },
    user: {
      required: () => 'ユーザー名を入力してください。',
      max: (name, max) => `${max}文字以内で入力してください。`,
    },
    phone: {
      required: () => '電話番号を入力してください。',
      max: (name, max) => `${max}文字以内で入力してください。`,
    },
    email: {
      required: () => 'メールアドレスを入力してください。',
      email: () => 'メールアドレス形式を正しく入力してください。',
      max: (name, max) => `${max}文字以内で入力してください。`,
      email_strict: () => 'メールアドレス形式を正しく入力してください'
    },
    staff_position: {
      required: () => '担当者役職を入力してください。',
      max: (name, max) => `${max}文字以内で入力してください。`,
    },
    employer_name: {
      required: () => '代表者名を入力してください。',
      max: (name, max) => `${max}文字以内で入力してください。`,
    },
    employer_position: {
      required: () => '代表者役職を入力してください。',
      max: (name, max) => `${max}文字以内で入力してください。`,
    },
    zipcode: {
      required: () => '郵便番号を入力してください。',
      max: (name, max) => `${max}文字以内で入力してください。`,
    },
    prefectures: {
      required: () => '都道府県を入力してください。',
      max: (name, max) => `${max}文字以内で入力してください。`,
    },
    cities: {
      required: () => '市区群・町村を入力してください。',
      max: (name, max) => `${max}文字以内で入力してください。`,
    },
    others: {
      required: () => '番地、アパート・マンション名等を入力してください。',
      max: (name, max) => `${max}文字以内で入力してください。`,
    },
    title: {
      required: () => 'お問い合わせ内容を選択してください。',
    },
    detail: {
      required: () => 'お問い合わせ内容を入力してください。',
      max: (name, max) => `最大${max}文字以内で入力してください。`,
    },
    agreed: {
      required: () => '個人情報の取り扱いについて同意してください。',
    },
  }
}

export default dict
